import { PaginatedResponse, Params, Transaction, WalletInfo } from '../types';
import { baseClient } from './client/instance';

const path = 'wallets';

export const connectWallet = async (address: string) => {
  const response = await baseClient.post(`${path}/connect-external`, {
    address,
  });
  return response.data;
};

export const verifySignature = async (address: string, signature: string) => {
  const response = await baseClient.post(`${path}/verify-signature`, {
    address,
    signature,
  });
  return response.data;
};

export const getWalletInfo = async () => {
  const response = await baseClient.get<WalletInfo>(`${path}/info`);
  return response.data;
};

export const getWalletTransactions = async (params?: Params) => {
  const response = await baseClient.get<PaginatedResponse<Transaction>>(
    `${path}/transactions`,
    {
      params,
    },
  );
  return response.data;
};
